var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTabMoreLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 52 52"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26 52C11.64 52 0 40.36 0 26S11.64 0 26 0s26 11.64 26 26-11.64 26-26 26"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  fillRule: "evenodd",
  d: "M2.167 26c0 13.163 10.67 23.833 23.833 23.833S49.833 39.163 49.833 26 39.163 2.167 26 2.167 2.167 12.837 2.167 26M0 26c0 14.36 11.64 26 26 26s26-11.64 26-26S40.36 0 26 0 0 11.64 0 26",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  fillRule: "evenodd",
  d: "M29.97 14.6a1.24 1.24 0 0 1 0 1.752L20.323 26l9.649 9.648A1.238 1.238 0 1 1 28.22 37.4L17.696 26.875a1.24 1.24 0 0 1 0-1.75L28.22 14.6a1.24 1.24 0 0 1 1.75 0",
  clipRule: "evenodd"
})));
export default SvgTabMoreLeft;